<template>
    <div
        class="o-guide-label"
    >
        <div 
            v-if="t(obj, 'icon')"
            class="o-guide-label__icon"
        >
            <img
                :src="t(obj, 'icon')"
                :alt="t(obj, 'name')"
                class="o-guide-label__icon-img"
            />
        </div>
        <div class="o-guide-label__info">
            <div class="o-guide-label__info-name">
                {{ t(obj,'name') }}
            </div>
            <div class="o-guide-label__info-floor">
                {{ getFloorName(obj) }}
            </div>
        </div>
        <!-- <span></span> -->
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: "OGuideLabel",
    props: {
        obj: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getPropsMapping',
            'getMapConfigProp',
            'getObjectFloorName',
            'getObjectFloorNameWithTypeOfName'
        ]),
        customFloorNameDisabled() {
            return this.componentParams.custom_floor_name_disabled
        },
        shortFloorName() {
            return this.componentParams.short_floor_name
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OGuideLabel.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OGuideLabel.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OGuideLabel.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        floorNameType() {
            return this.componentParams.floor_name_type
        }
    },
    methods: { 
        getFloorName(object) {
            if(this.floorNameType) {
                return this.getObjectFloorNameWithTypeOfName(object, this.floorNameType, this.componentParams.floor_debug_id)
            }

            return this.getObjectFloorName(object)
        },
    }
}
</script>

<style lang="scss">
@import "o-guide-label";
</style>
